module.exports = __webpack_public_path__ + "static/media/sbtn.59da45ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/active20/sbtn.png
// module id = 813
// module chunks = 0